import type { ReactNode } from 'react';

/**
 * LINKS CLICKEABLES EN TEXTO PLANO (pedido del dueño 2026-09-12: "haz los links clickeables de los
 * SMS"). Un SMS es texto: el link del update semanal al homeowner (`https://app…/p/update/…`) salía
 * como letras sueltas. Se parte el texto por URLs (http/https, y `www.` sin esquema) y cada una se
 * vuelve <a> en pestaña nueva. La puntuación final (".", ",", ")") no forma parte del link.
 * `onDark` = burbuja propia (fondo de acento): el link va en blanco para que se lea.
 */
const URL_RE = /((?:https?:\/\/|www\.)[^\s<>"']+)/gi;

export function partirLinks(text: string): Array<{ url: string; text: string } | string> {
  const out: Array<{ url: string; text: string } | string> = [];
  let last = 0; let m: RegExpExecArray | null;
  URL_RE.lastIndex = 0;
  while ((m = URL_RE.exec(text))) {
    let raw = m[1]!;
    // Puntuación de cierre que no es del link (y un paréntesis sin abrir adentro).
    let cola = '';
    while (/[.,;:!?'")\]]$/.test(raw)) {
      const ch = raw.slice(-1);
      if (ch === ')' && (raw.match(/\(/g)?.length ?? 0) >= (raw.match(/\)/g)?.length ?? 0)) break;
      cola = ch + cola; raw = raw.slice(0, -1);
    }
    if (m.index > last) out.push(text.slice(last, m.index));
    out.push({ url: /^www\./i.test(raw) ? `https://${raw}` : raw, text: raw });
    if (cola) out.push(cola);
    last = m.index + m[1]!.length;
  }
  if (last < text.length) out.push(text.slice(last));
  return out;
}

export function renderLinks(text: string, onDark = false): ReactNode {
  const style = onDark
    ? { color: '#fff', textDecoration: 'underline', fontWeight: 600, overflowWrap: 'anywhere' as const }
    : { color: 'var(--accent)', textDecoration: 'underline', fontWeight: 600, overflowWrap: 'anywhere' as const };
  return partirLinks(text).map((p, i) => typeof p === 'string'
    ? p
    : <a key={i} href={p.url} target="_blank" rel="noopener noreferrer" style={style} onClick={(e) => e.stopPropagation()}>{p.text}</a>);
}
